import useSWR from 'swr';
import { EnabledChains } from '../../config/constants';
import { useWeb3React } from '@web3-react/core';
import { config } from '../../config/config';
import { formatUnits } from 'ethers/lib/utils';
import useTokenDetails from '../web3/useTokenDetails';

const usePlatformStats = () => {
    const { chainId } = useWeb3React();

    const { decimals } = useTokenDetails(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    const { data, error, mutate } = useSWR(
        chainId && decimals ? ['platformStats', chainId, decimals] : null,
        async (_, __, decimals) => {
            // if (!verifyChainConfig(chainId)) return;

            // const query = `
            //     dataPoints(where: {periodType:TOTAL}){
            //         totalValueLockedTotal
            //         tradingVolumeTotal
            //         protocolFeeTotal
            //     }
            // `;

            // const data: {
            //     dataPoints: Pick<
            //         DataPoint,
            //         'totalValueLockedTotal' | 'tradingVolumeTotal' | 'protocolFeeTotal'
            //     >[];
            // } = await subgraphQuery(query, {
            //     chainId,
            // });

            // const { totalValueLockedTotal, tradingVolumeTotal, protocolFeeTotal } =
            //     data.dataPoints[0];

            return {
                totalValueLocked: formatUnits('123451231211231', decimals),
                totalTradingVolume: formatUnits('100012314445', decimals),
                totalProtocolFees: formatUnits('11111119121', decimals),
            };
        }
    );

    return {
        platformStats: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};

export default usePlatformStats;
